export const SUMMARY_PLACEMENT_SETTING = 'SUMMARY_PLACEMENT';
export const SUMMARY_PLACEMENT_HEADER = 'HEADER';
export const SUMMARY_PLACEMENT_FOOTER = 'FOOTER';